import { render, staticRenderFns } from "./container.vue?vue&type=template&id=b2bcf8f6&scoped=true&"
import script from "./container.vue?vue&type=script&lang=ts&"
export * from "./container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bcf8f6",
  null
  
)

export default component.exports